module.exports = __webpack_public_path__ + "img/lg_no_ring@2x.2b59d6b0.png";